<template>
  <data-list
    ref="dataList"
    class="content"
    url="/activity/activity-meal-set"
    entity-name="订餐时间"
    add-btn="添加"
    hide-show-detail
    :before-update="beforeUpdate"
    :hide-action="!editable"
    :modal-width="600"
    :modal-form="modalForm"
    :query="query"
    :action="action"
    :columns="columns"
    :rules="rules">
    <template v-slot:edit="{form}">
      <a-form-model-item label="订餐时间（中文）" prop="chinese_name">
        <a-input v-model="form.chinese_name" placeholder="请输入订餐时间（中文）"></a-input>
      </a-form-model-item>
      <a-form-model-item label="订餐时间（英文）" prop="english_name">
        <a-input v-model="form.english_name" placeholder="请输入订餐时间（英文"></a-input>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import mixins from "../mixins";

    export default {
        name: "FoodTime",
        data() {
            return {
                dateList: [],
                timeList: [],
                columns: [
                    {title: '订餐时间（中文）', dataIndex: 'chinese_name'},
                    {title: '订餐时间（英文）', dataIndex: 'english_name'},
                ],
                rules: {
                    chinese_name: [{ required: true, message: '请输入订餐时间（中文）', trigger: 'blur' }],
                    english_name: [{ required: true, message: '请输入订餐时间（英文）', trigger: 'blur' }],
                },
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'food-time',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                fn();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
